import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";

import { t } from "./i18n/t";

// expose globally for quick adoption across pages without refactor
window.t = t;

// Apply saved theme before first paint (public + app pages)
(() => {
  try {
    const th = localStorage.getItem("ca_theme") || "dark";
    document.documentElement.setAttribute("data-theme", th === "light" ? "light" : "");
  } catch (_) {}
})();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
